'use client';

import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { parseMutationArgs, MutationObserver, notifyManager } from '@tanstack/query-core';
import { useSyncExternalStore } from './useSyncExternalStore.mjs';
import { useQueryClient } from './QueryClientProvider.mjs';
import { shouldThrowError } from './utils.mjs';
function useMutation(arg1, arg2, arg3) {
  var options = parseMutationArgs(arg1, arg2, arg3);
  var queryClient = useQueryClient({
    context: options.context
  });
  var _React$useState = React.useState(function () {
      return new MutationObserver(queryClient, options);
    }),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    observer = _React$useState2[0];
  React.useEffect(function () {
    observer.setOptions(options);
  }, [observer, options]);
  var result = useSyncExternalStore(React.useCallback(function (onStoreChange) {
    return observer.subscribe(notifyManager.batchCalls(onStoreChange));
  }, [observer]), function () {
    return observer.getCurrentResult();
  }, function () {
    return observer.getCurrentResult();
  });
  var mutate = React.useCallback(function (variables, mutateOptions) {
    observer.mutate(variables, mutateOptions).catch(noop);
  }, [observer]);
  if (result.error && shouldThrowError(observer.options.useErrorBoundary, [result.error])) {
    throw result.error;
  }
  return _objectSpread(_objectSpread({}, result), {}, {
    mutate: mutate,
    mutateAsync: result.mutate
  });
} // eslint-disable-next-line @typescript-eslint/no-empty-function

function noop() {}
export { useMutation };